import React, { Component } from 'react';
import {provideIntlService } from '@progress/kendo-react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

//THIS COMPONENT IS ONLY GOOD FOR PHONE NUMBERS THAT ARE TEN DIGITS LONG, AND WHOSE FORMAT NEED TO BE (XXX) XXX-XXXX

class GridPhoneFormatter extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    formatNumber = (number_string) => {
        
        return number_string.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
           
    }

	render() {
		return (
			<td colSpan={this.props.colSpan} style={this.props.style}>
                {
                    this.props.dataItem.phone != null ?
                    this.formatNumber(this.props.dataItem.phone)
                    : ''
                }
			</td>
		);
	}
}
export default withRouter(connect(
)(GridPhoneFormatter));